import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
//
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { TPL } from '../models';
import { SelectItem } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { ShipmentPartner } from '../models/shipmentPartner.model';

@Injectable()
export class TPLService extends GeneralService {
  partners: SelectItem[];
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "TPL");
  }

  getAllTPL() {
    return this.getAll().map(x => {
      let data = x.data as TPL[];
      this.partners = [];
      this.partners.push({ label: "--Chọn đối tác--", value: null });
      if (data) {
          data.forEach(element => {
              this.partners.push({ label: element.name, value: element.id });
          });
      }
      return this.partners;
    });
  }

  async getAllSelectItemTPLAsync (): Promise<SelectItem[]> {
    const res = await this.getAll().toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as TPL[];
    let tpls: SelectItem[] = [];
    data.forEach(element => {
      tpls.push({ label: element.code, value: element.id });
    });
    return tpls;
  }

  async getListServiceAhamove (lat:any, lng:any): Promise<any[]> {
    let params = new HttpParams();
    params = params.append('lat',lat);
    params = params.append('lng',lng);
    const res = await this.getCustomApi("GetListServiceAhamove",params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async createOrderAhamove(model:ShipmentPartner){
    const res = await super.postCustomApi("CreateOrderAhamove", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async estimatedFee(model:ShipmentPartner){
    const res = await super.postCustomApi("EstimatedFee", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  
  async getListOrderAhamove(fromDate:any, toDate:any,pageNumber:any){
    let params = new HttpParams();
    params = params.append('fromDate',fromDate)
    params = params.append('toDate',toDate)
    params = params.append('pageNumber',pageNumber)
    
    const res = await this.getCustomApi("GetListOrderAhamove", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  
  async cancelOrderAhamove(orderId:any, reason:any){
    let params = new HttpParams();
    params = params.append('orderId',orderId)
    params = params.append('reason',reason)
    
    const res = await this.getCustomApi("CancelOrderAhamove", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  
  async getListShipmentInOrderAhamove(orderId:any,pageNumber:any,pageSize:any){
    let params = new HttpParams();
    params = params.append('orderId',orderId)
    params = params.append('pageNumber',pageNumber)
    params = params.append('pageSize',pageSize)
    
    const res = await this.getCustomApi("GetListShipmentInOrderAhamove", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  
  async getOrderTrackingLink(orderId:any){
    let params = new HttpParams();
    params = params.append('orderId',orderId)
    
    const res = await this.getCustomApi("GetOrderTrackingLink", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
}
